module.exports = __webpack_public_path__ + "hindi-logo-b41fea99e2787b389302.png";